import { Theme } from '@mui/material/styles';

export const formStyles: any = {
  root: {
    maxWidth: 850,
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column'
  },
  accordion: {
    color: (theme: Theme) => theme.palette.primary.contrastText,
    width: '100%'
  },
  input: {
    // backgroundColor: theme.palette.primary.contrastText
    color: (theme: Theme) => theme.palette.primary.contrastText,
    maxWidth: {
      xs: 320,
      sm: 550
    },
    width: '100%',
  },
  dialogRoot: {
    color: (theme: Theme) => theme.palette.primary.contrastText,
    padding: 8,
    // backgroundColor: '#FAFAFA',
    // borderRadius: 12,
    '& > :not(:last-child)': {
      marginBottom: 12
    }
  },
  section: {
    maxWidth: 850,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    padding: 3,
    '& > :not(:last-child)': {
      marginBottom: 4
    }
  },
  sectionForm: {
    maxWidth: 850,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    padding: 12,
    '& > :not(:last-child)': {
      marginBottom: 16
    }
  },
  expanded: {
    margin: '0 !important'
  }
};
